module.exports = __webpack_public_path__ + "static/media/bad-dream-3d.adc9d833.jpg";